
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {IForm} from '@/interfaces/form';


@Component({})
export default class RendererDialog extends Vue {
  @Prop()
  public formData!: IForm;
  @Prop()
  private buttonTitle!: string;
  @Prop()
  private isPreviewList!: boolean;

  private dialog: boolean = false;
  private validationOk: boolean = false;

  @Watch('dialog')
  public watchDialogOption(val) {
    if (!val) {
      // @ts-ignore
      this.$formEvent.$off('renderer.validation_ok');
      // @ts-ignore
      this.$formEvent.$once('renderer.validation_ok', this.changeValidation);
    }
  }

  public async mounted() {
    // @ts-ignore
    this.$formEvent.$off('renderer.validation_ok');
    // @ts-ignore
    this.$formEvent.$once('renderer.validation_ok', this.changeValidation);
  }

  private testValidation(): void {
    // @ts-ignore
    this.$formEvent.$emit('renderer.run_validation', true);
  }

  private changeValidation() {
    // @ts-ignore
    // this.$formEvent.$off('renderer.run_validation');
    this.validationOk = true;
    // @ts-ignore
    this.$formEvent.$once('renderer.validation_ok', this.changeValidation);
  }
}
